import React, { Component } from "react";
import "antd/dist/antd.css";
import { Row, Col, Button, Modal, Form, Input, message } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import Amplify, { Auth } from "aws-amplify";
import awsConfigure from "../Config/AwsConfig";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
Amplify.configure(awsConfigure);

class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      confirmDirty: false,
      redirect:false
    };
    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
  }

  showModal = () => {
    this.setState({ show: true });
  };

  hideModal = () => {
    this.setState({ show: false });
    this.props.form.setFieldsValue({
      oldPassword: "",
      newPassword: "",
      confirm: "",
    });
  };

  handleConfirmBlur = (e) => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  compareToFirstPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && value !== form.getFieldValue("newPassword")) {
      callback("Two passwords that you enter is inconsistent!");
    } else {
      callback();
    }
  };

  validateToNextPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && this.state.confirmDirty) {
      form.validateFields(["confirm"], { force: true });
    }
    callback();
  };

  changePassword = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(
      ["oldPassword", "newPassword", "confirm"],
      (err, values) => {
        if (!err) {
          this.setState({
            loading: true,
          });
          Auth.currentAuthenticatedUser()
            .then((user) => {
              return Auth.changePassword(
                user,
                values["oldPassword"],
                values["newPassword"]
              );
            })
            .then((data) => {
              message.success("Password changed successfully! Now relogin With New Password");
              this.setState({ redirect: true});
            })
            .catch((err) => {
              if (err["code"] === "NotAuthorizedException") {
                message.error("Invalid old password!");
                this.setState({ loading: false });
              } else {
                message.error(err["message"]);
                this.setState({ loading: false });
              }
              console.log(err);
            });
        }
      }
    );
  };

  render() {
    const { getFieldDecorator} = this.props.form;

    if (this.state.redirect) {
      return <Redirect to='/login'/>;
    }

    return (
      <main>
        <span
          style={{ cursor: "pointer" }}
          onClick={() => {
            this.showModal();
          }}
        >
          <h4
            style={{
              color: this.props?.color ? this.props.color : "#1890ff",
              fontSize: "13px",
              textAlign: "center",
            }}
          >
            Change password
          </h4>
        </span>
        <Form>
          <Modal
            visible={this.state.show}
            closable={true}
            footer={[
              <Button key="submit" className="cancel" onClick={this.hideModal}>
                Cancel
              </Button>,
              <Button
                type="primary"
                key="editSubmit"
                htmlType="submit"
                loading={this.state.loading}
                onClick={this.changePassword}
              >
                Change password
              </Button>,
            ]}
          >
            <CloseOutlined
              onClick={this.hideModal}
              style={{ float: "right", cursor: "pointer", fontSize: "1.4em" }}
            />
            <div>
              <h1 style={{ textAlign: "center" }}>Change password</h1>
              <Row>
                <Col lg={20} md={20} sm={24} xs={24}>
                  <Form.Item
                    className="Formitem"
                    label={
                      <span style={{ color: "#0E4D90" }}>Old Password</span>
                    }
                  >
                    {getFieldDecorator("oldPassword", {
                      rules: [
                        {
                          required: true,
                          message: "Please input your old password",
                        },
                      ],
                    })(
                      <Input.Password
                        placeholder="*********"
                        autoComplete="new-password"
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col lg={20} md={20} sm={24} xs={24}>
                  <Form.Item
                    className="Formitem"
                    label={<span className="label">New Password</span>}
                    hasFeedback
                  >
                    {getFieldDecorator("newPassword", {
                      rules: [
                        {
                          required: true,
                          message: "Please input your new password!",
                        },
                        { validator: this.validateToNextPassword },
                      ],
                    })(
                      <Input.Password
                        placeholder="*********"
                        autoComplete="new-password"
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col lg={20} md={20} sm={24} xs={24}>
                  <Form.Item
                    className="Formitem"
                    label={<span className="label">Confirm New Password</span>}
                    hasFeedback
                  >
                    {getFieldDecorator("confirm", {
                      rules: [
                        {
                          required: true,
                          message: "Please confirm your password!",
                        },
                        { validator: this.compareToFirstPassword },
                      ],
                    })(
                      <Input.Password
                        placeholder="*********"
                        onBlur={this.handleConfirmBlur}
                      />
                    )}
                  </Form.Item>
                </Col>
              </Row>
            </div>
          </Modal>
        </Form>
      </main>
    );
  }
}

export default Form.create({ name: "ChangePassword" })(ChangePassword);
// export default ChangePassword